import Fonts from './shared/Fonts';
import Countdown from './shared/Countdown';

export default function GraduacionModerna({ data, title }) {
  const d = data || {};
  const graduate = d.graduate || 'El graduado';
  const career = d.career;
  const date = d.date ? new Date(d.date) : null;

  const dateStr = date
    ? date.toLocaleDateString('es-PE', {
        weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
      })
    : null;

  const colors = {
    bg: '#0f0f14',
    accent: '#ffb547',
    accent2: '#ff7a59',
    text: '#ffffff',
    muted: '#8b8b9a',
    card: '#1a1a24',
  };

  const display = "'Space Grotesk', sans-serif";
  const body = "'Inter', sans-serif";

  return (
    <div
      className="min-h-screen w-full relative overflow-hidden"
      style={{ background: colors.bg }}
    >
      <Fonts for="gradu" />

      {/* Grid de fondo */}
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage: `linear-gradient(${colors.accent} 1px, transparent 1px), linear-gradient(90deg, ${colors.accent} 1px, transparent 1px)`,
          backgroundSize: '40px 40px',
        }}
      />

      {/* Gradiente superior */}
      <div
        className="absolute top-0 left-0 right-0 h-96 pointer-events-none"
        style={{
          background: `radial-gradient(ellipse at top, ${colors.accent}22 0%, transparent 60%)`,
        }}
      />

      <div className="relative">
        {/* Hero */}
        <section className="px-6 pt-24 pb-16 sm:pt-32 sm:pb-20">
          <div className="max-w-4xl mx-auto">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-3 h-3 rounded-full" style={{ background: colors.accent }} />
              <div className="w-8 h-0.5" style={{ background: colors.accent }} />
              <p
                className="text-xs tracking-[0.4em] uppercase"
                style={{ color: colors.accent, fontFamily: display, fontWeight: 600 }}
              >
                Graduación
              </p>
            </div>

            <h1
              className="text-4xl sm:text-7xl leading-none mb-4"
              style={{ fontFamily: display, fontWeight: 700, color: colors.text, letterSpacing: '-0.02em' }}
            >
              {graduate}
            </h1>

            {career && (
              <p
                className="text-xl sm:text-2xl mb-8"
                style={{ fontFamily: display, color: colors.accent, fontWeight: 500 }}
              >
                {career}
              </p>
            )}

            <p
              className="text-base sm:text-lg max-w-xl"
              style={{ fontFamily: body, color: colors.muted }}
            >
              {title || 'Celebremos juntos el fin de una etapa y el comienzo de otra.'}
            </p>

            <div className="flex gap-2 mt-10">
              <div className="h-1 w-16" style={{ background: colors.accent }} />
              <div className="h-1 w-8" style={{ background: colors.accent2 }} />
              <div className="h-1 w-4" style={{ background: colors.text, opacity: 0.3 }} />
            </div>
          </div>
        </section>

        {/* Cuenta regresiva */}
        {date && (
          <section className="px-6 py-12">
            <div
              className="max-w-3xl mx-auto rounded-2xl p-8"
              style={{
                background: colors.card,
                border: `1px solid ${colors.accent}22`,
              }}
            >
              <p
                className="text-center text-xs tracking-widest uppercase mb-6"
                style={{ color: colors.accent, fontFamily: display, fontWeight: 600 }}
              >
                Cuenta regresiva
              </p>
              <Countdown target={date} accent={colors.accent} labelColor={colors.muted} />
            </div>
          </section>
        )}

        {/* Info en grid */}
        <section className="px-6 py-12">
          <div className="max-w-4xl mx-auto grid sm:grid-cols-2 gap-4">
            {dateStr && (
              <div
                className="rounded-2xl p-6"
                style={{ background: colors.card, border: `1px solid ${colors.accent}22` }}
              >
                <p
                  className="text-xs tracking-widest uppercase mb-3"
                  style={{ color: colors.muted, fontFamily: display }}
                >
                  01 / Cuándo
                </p>
                <p
                  className="text-xl font-semibold capitalize"
                  style={{ fontFamily: display, color: colors.text }}
                >
                  {dateStr}
                </p>
                {d.time && (
                  <p className="text-base mt-1" style={{ fontFamily: body, color: colors.accent }}>
                    {d.time}
                  </p>
                )}
              </div>
            )}

            {d.place && (
              <div
                className="rounded-2xl p-6"
                style={{ background: colors.card, border: `1px solid ${colors.accent}22` }}
              >
                <p
                  className="text-xs tracking-widest uppercase mb-3"
                  style={{ color: colors.muted, fontFamily: display }}
                >
                  02 / Dónde
                </p>
                <p
                  className="text-xl font-semibold"
                  style={{ fontFamily: display, color: colors.text }}
                >
                  {d.place}
                </p>
                {d.address && (
                  <p className="text-sm mt-1" style={{ fontFamily: body, color: colors.muted }}>
                    {d.address}
                  </p>
                )}
              </div>
            )}
          </div>
        </section>

        {/* Mensaje */}
        {d.description && (
          <section className="px-6 pb-16">
            <div className="max-w-2xl mx-auto">
              <div className="flex items-start gap-4">
                <div
                  className="text-6xl leading-none"
                  style={{ color: colors.accent, fontFamily: display, opacity: 0.4 }}
                >
                  "
                </div>
                <p
                  className="text-lg sm:text-xl leading-relaxed pt-3"
                  style={{ fontFamily: body, color: colors.text, opacity: 0.9 }}
                >
                  {d.description}
                </p>
              </div>
            </div>
          </section>
        )}

        <footer className="pb-10 text-center">
          <p className="text-xs" style={{ fontFamily: body, color: colors.muted }}>
            Invitación creada con <b style={{ color: colors.accent }}>Go Fiesta</b>
          </p>
        </footer>
      </div>
    </div>
  );
}